/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Heading } from '@vaisala-rockhopper/components';
import { useTranslation } from 'react-i18next';
import './CalculatorCardHeading.scss';
import InfoButton from '../navigation/InfoButton';
import PhaseIndicator, { PhaseIndicatorProps } from '../navigation/PhaseIndicator';
import { ModalType } from '../modals/Modals';
import { OptionsConfig } from '../modals/OptionsModal';

interface CalculatorCardHeadingProps extends PhaseIndicatorProps {
  title: string;
  openModal: (type: ModalType, title?: string, optionsConfig?: OptionsConfig, onAccept?: VoidFunction, onReject?: VoidFunction) => void;
  cardsLength: number;
}

const CalculatorCardHeading = ({ title, openModal, cardsLength, ...rest }: CalculatorCardHeadingProps) => {
  const { t } = useTranslation();
  return (
    <div className="calculator-card-heading">
      <Heading level={4}>{t(title)}</Heading>
      <InfoButton onButtonClick={() => openModal(`modal.${title.replace('card.', '')}`)} />
      {cardsLength > 1 && <PhaseIndicator {...rest} />}
    </div>
  );
};

export default CalculatorCardHeading;
